import { Component } from '@angular/core';

@Component({
  selector: 'app-store-layout',
  standalone: false,
  
  templateUrl: './store-layout.component.html',
  styleUrl: './store-layout.component.scss'
})
export class StoreLayoutComponent {

}
